import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const footerLinks = [
    { to: '/category/korean', label: '韩漫专区' },
    { to: '/category/japanese', label: '日漫专区' },
    { to: '/category/chinese', label: '国漫专区' },
    { to: '/category/american', label: '美漫专区' },
    { to: '/about', label: '关于我们' },
    { to: '/about', label: '免责声明' },
  ];

  return (
    <footer className="bg-foreground-950 rounded-3xl mx-4 md:mx-6 mb-6">
      <div className="px-8 md:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h3 className="text-2xl font-heading font-bold text-background-50 mb-4">
              订阅我们的更新
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed mb-5 max-w-sm">
              第一时间获取最新漫画更新通知和独家推荐内容，精彩不容错过。
            </p>
            <form className="flex flex-col sm:flex-row gap-2 max-w-md" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱地址"
                className="flex-1 bg-transparent border-0 border-b border-foreground-500 px-2 py-2.5 text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-primary-400 transition-colors"
              />
              <button
                type="submit"
                className="px-6 py-2.5 rounded-full bg-background-50 text-foreground-950 text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer flex items-center gap-2"
              >
                订阅 <i className="ri-arrow-right-line text-base"></i>
              </button>
            </form>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  className="text-sm text-foreground-400 hover:text-primary-300 transition-colors whitespace-nowrap py-1 border-b border-transparent hover:border-foreground-500"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="space-y-2 text-sm text-foreground-400">
              <p>邮箱：hello@junyitea.cn</p>
              <p>地址：韩国首尔市江南区</p>
              <p>工作时间：周一至周日 9:00-21:00</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-foreground-500">
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-primary-300 transition-colors whitespace-nowrap">微博</a>
            <a href="#" className="hover:text-primary-300 transition-colors whitespace-nowrap">微信</a>
            <a href="#" className="hover:text-primary-300 transition-colors whitespace-nowrap">B站</a>
          </div>
          <p className="text-center whitespace-nowrap">&copy; 2026 55漫画网 版权所有</p>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-primary-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-300 transition-colors whitespace-nowrap">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}